import { render, staticRenderFns } from "./TabletStandard.vue?vue&type=template&id=63bdc29c&scoped=true&"
import script from "./TabletStandard.vue?vue&type=script&lang=js&"
export * from "./TabletStandard.vue?vue&type=script&lang=js&"
import style0 from "./TabletStandard.vue?vue&type=style&index=0&id=63bdc29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bdc29c",
  null
  
)

export default component.exports